import { PackageType, PackageSet, RoutePackageMap } from '~shared/types/pricing/package';
import { Packages } from '~shared/constants/pricing';

export const EXTERNAL_SCRIPTS: readonly string[] = Object.freeze(['https://js.stripe.com/v3/']);

export const MONTHLY_PACKAGES: PackageSet = [
  Packages.StandardMonthly,
  Packages.AdvantageMonthly,
  Packages.PremierMonthly,
];

export const INDIVIDUAL_PACKAGES: PackageSet = [
  Packages.PremierAnnual,
  Packages.AdvantageAnnual,
  Packages.StandardMonthly,
  Packages.Basic,
];

// For now, the educational package set is identical to what we show for
// individual details. That may change some day, though, so making an explicitly
// named set here in case that ever changes. The shallow copy is to prevent any
// unexpected results when doing equality checks elsewhere
export const EDUCATIONAL_PACKAGES: PackageSet = [...INDIVIDUAL_PACKAGES];

export const TEAMS_PACKAGES: PackageSet = [Packages.TeamAdvantage, Packages.TeamPremier, Packages.Enterprise];

export const SUITE_PRICING_PACKAGES: PackageSet = [
  Packages.AdvantageAnnual,
  Packages.TeamAdvantage,
  Packages.TeamPremier,
];

// As of 2023/05/09, only annual packages are eligible for stripe checkout
export const STRIPE_ELIGIBLE_PACKAGES: PackageSet = [
  Packages.StandardAnnual,
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.TeamAdvantage,
  Packages.TeamPremier,
];

export const GUAC_COUNTRY_CODES = Object.freeze(['GB', 'US', 'AU', 'CA']);

export const COMPARISON_PACKAGES: Partial<Record<Packages, Packages>> = {
  [Packages.TeamAdvantage]: Packages.AdvantageAnnual,
  [Packages.TeamPremier]: Packages.PremierAnnual,
};

// A list of packages that should display highlighted
export const HIGHLIGHTED_PACKAGES = [Packages.AdvantageAnnual];

// these domains do not get hreflang tags added to their <head>
export const SKIP_HREF_LANG_TAGS = Object.freeze({
  'de.surveymonkey.com': true,
  'ru.surveymonkey.com': true,
});

// Package type(route) and comparison packages mapping
export const ROUTE_PACKAGE_MAP: RoutePackageMap = {
  [PackageType.Individual]: INDIVIDUAL_PACKAGES,
  [PackageType.Teams]: TEAMS_PACKAGES,
  [PackageType.Educational]: EDUCATIONAL_PACKAGES,
};
